module.exports = __webpack_public_path__ + "img/tema-3-7.7928f5f3.png";